import _ from 'lodash'
import {Select} from '../select'
import {useFloatingSelectContext, useSelectContext} from '../../context'
import {SelectItemDot} from '../select_item_dot'
import {CosmeticCheckbox} from '~/components/checkbox'

export const SelectNestedGroup = ({item}) => {
	const {value, type, updateValue, getSelectedItems} = useSelectContext()
	const {listRef, activeIndex, getItemProps, focusedNestedGroup} = useFloatingSelectContext()

	const {
		data: {label, subItems, t, dotColor},
		originalIndex,
	} = item
	const active = activeIndex === originalIndex
	const isFocused = active && focusedNestedGroup === originalIndex

	const selectedSubItemValues = getSelectedItems(subItems)._map('value')
	const isAllSelected = selectedSubItemValues.length === subItems.length
	const isPartiallySelected = selectedSubItemValues.length > 0 && !isAllSelected

	const checkboxState = isPartiallySelected ? 'indeterminate' : isAllSelected

	const itemProps = getItemProps({
		onClick: () => updateValue(subItems),
	})

	// This function handles changes in nested select items by:
	// 1. Finding items that are in data but not in selectedSubItemValues (newly selected)
	// 2. Finding items that are in selectedSubItemValues but not in data (newly deselected)
	// 3. Combining these differences into a new array and formatting each value
	const handleChange = data => {
		const newValues = [
			..._.difference(data, selectedSubItemValues), // Add newly selected items
			..._.difference(selectedSubItemValues, data), // Add newly deselected items
		]

		// Convert each value to an object with a value property
		updateValue(newValues.map(value => ({value})))
	}

	const selectItemRef = node => {
		if (listRef && node) {
			listRef.current[originalIndex] = node
		}
	}

	return (
		<Select
			ref={selectItemRef}
			trigger={{
				t: t || label,
				className: 'select-item',
				active,
				leftElement: (
					<>
						<CosmeticCheckbox checked={checkboxState} />
						<SelectItemDot dotColor={dotColor} />
					</>
				),
				...itemProps,
			}}
			value={value}
			items={subItems}
			type={type}
			placement="right-start"
			onChange={handleChange}
			open={isFocused}
		/>
	)
}
